import React from 'react'
import { Navigate, Route, Routes } from 'react-router'
import MainPage from './MainPage'
import Corpus from './Corpus/Corpus'
import MilUnit from './MilUnit/MilUnit'
import Battalion from './Battalion/Battalion'
import Company from './Company/Company'
import Weapon from './Weapon/Weapon'
import Login from './Login/Login'
import Register from './Login/Register'
import { RequireAuthMain } from './Login/RequireAuth'
import BaseList from './BaseList/BaseList'
import ProfileSettings from './Profile/ProfileSettings'
import Firing from './Firing/Firing'
import Accident from './Accident/Accident'
import Check from './Check/Check'
import Platoon from './Platoon/Platoon'
import People from './people/People'
import AccidentUnit from './AccidentUnit/AccidentUnit'
import CheckUnit from './CheckUnit.jsx/CheckUnit'
import Users from './Users/Users'

export default function Router() {
  return (
    <Routes>
        <Route path='/' element={<RequireAuthMain><MainPage/></RequireAuthMain>}>
            <Route index element={<Navigate to='/base' />} />
            <Route path='profile' element={<ProfileSettings />} />
            <Route path='base' element={<BaseList/>} />
            <Route path="corpus" element={<Corpus/>} /> 
            <Route path='mil_unit' element={<MilUnit/>} />
            <Route path="battalion" element={<Battalion/>} />
            <Route path="company" element={<Company/>} />
            <Route path="platoon" element={<Platoon/>} />
            <Route path="weapon" element={<Weapon/>} />
            <Route path="people" element={<People/>} />
            <Route path="check" element={<Check/>} />
            <Route path='check-unit' element={<CheckUnit />}/>
            <Route path='accident' element={<Accident />}/>
            <Route path='accident-unit' element={<AccidentUnit />}/>
            <Route path='firing' element={<Firing />}/>
            <Route path='user' element={<Users/>} />
        </Route>
        <Route path='/login' element={<Login/>} />
        <Route path='/reg' element={<Register/>} />
        <Route path="*" element={<Navigate to="/base" />} />
    </Routes>
  )
}
